import * as actionTypes from '../actions/actionTypes';
import _ from 'lodash';

const DEFAULT_STATE = {
  auth: {},
  profile: {},
};

function resolveDjangoError(action) {
  return _.get(action.error, 'response.status') === 400
    ? _.get(action.error, 'response.data', {})
    : {
      non_field_errors: [_.toString(
        _.get(action.error, 'response.data.detail', _.get(action.error, 'response.data', ''))
      )],
    };
}

const errorReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case '@@router/LOCATION_CHANGE': {
      return DEFAULT_STATE;
    }
    case actionTypes.LOG_IN:
    case actionTypes.SIGN_UP:
    case actionTypes.REQUEST_ACTIVATION_CODE:
    case actionTypes.VALIDATE_CODE:
    case actionTypes.RESET_PASSWORD: {
      return {
        ...state,
        auth: DEFAULT_STATE.auth,
      };
    }
    case actionTypes.USER_PROFILE_CHANGE: {
      return {
        ...state,
        profile: DEFAULT_STATE.profile,
      };
    }
    case actionTypes.LOG_IN_FAILED:
    case actionTypes.SIGN_UP_FAILED:
    case actionTypes.REQUEST_ACTIVATION_CODE_FAILED:
    case actionTypes.REQUEST_RESET_CODE_FAILED:
    case actionTypes.REQUEST_EMAIL_EDIT_CODE_FAILED:
    case actionTypes.VALIDATE_CODE_FAILED:
    case actionTypes.RESET_PASSWORD_FAILED: {
      return {
        ...state,
        auth: resolveDjangoError(action),
      };
    }
    case actionTypes.USER_PROFILE_CHANGE_FAILED: {
      return {
        ...state,
        profile: resolveDjangoError(action),
      };
    }
    default: {
      return state;
    }
  }
};

export default errorReducer;



// WEBPACK FOOTER //
// /src/redux/reducers/errorReducer.js